import React, { useState, useRef } from 'react';
import { StarFilled } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';

const StarRating = ({
    containerStyle = {},
    form,
    name,
    label,
    defaultValue,
}) => {
    const [selected, setSelected] = useState(defaultValue || 0);
    const [hovered, setHovered] = useState(0);
    const [animate, setAnimate] = useState(false);
    const prevSelected = useRef(defaultValue || 0);

    React.useEffect(() => {
        form.setFieldValue(name, defaultValue);
    }, [form, name, defaultValue]);

    // Keep prevSelected in sync with selected
    React.useEffect(() => {
        prevSelected.current = selected;
    }, [selected]);

    // Animation trigger
    React.useEffect(() => {
        if (selected) {
            setAnimate(true);
            const timeout = setTimeout(() => setAnimate(false), 600);
            return () => clearTimeout(timeout);
        }
    }, [selected]);

    // Your custom colors for each star
    const fillColors = [
        '#ff0000ff', // 1st star
        '#e98888ff', // 2nd star
        '#ffe58f',   // 3rd star
        '#ebd254ff', // 4th star
        '#e1ff00ff', // 5th star
    ];

    // Helper to get color for each star
    const getStarColor = (val, idx) => {
        if (hovered) {
            return val <= hovered ? fillColors[hovered - 1] : '#e4e4e4';
        }
        if (selected) {
            if (selected >= prevSelected.current) {
                return val <= selected ? fillColors[selected - 1] : '#e4e4e4';
            } else {
                return val <= selected ? fillColors[idx] : '#e4e4e4';
            }
        }
        return '#e4e4e4';
    };

    const handleClick = (val) => {
        setSelected(val);
        form.setFieldValue(name, val);
    };

    return (
        <>
            <Row className='ant-form-item-row'>
                <Col span={24} className='ant-form-item-label'>
                    <label className='ant-form-item-no-colon' title={label}>{label}</label>
                </Col>
            </Row>
            <div style={{ padding: 15, display: 'flex', ...containerStyle, justifyContent: 'space-around', border: '1px solid #9c9c9c', borderRadius: 10 }}>
                <Form.Item name={name} hidden />
                {[1, 2, 3, 4, 5].map((val, idx) => (
                    <StarFilled
                        key={val}
                        onMouseEnter={() => setHovered(val)}
                        onMouseLeave={() => setHovered(0)}
                        onClick={() => handleClick(val)}
                        className={animate && val <= selected ? 'star-sparkle' : ''}
                        style={{
                            cursor: 'pointer',
                            fontSize: 24,
                            color: getStarColor(val, idx),
                            transition: 'color 0.2s',
                        }}
                    />
                ))}
            </div>
        </>
    );
};

export default StarRating;